"use client";

import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";
import { SessionProvider } from "next-auth/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useAuthStore, type AuthState } from "@/store/authStore";
import { isPathRequiringAuth } from "@/lib/auth-redirect";
import { Toaster } from "@/components/ui/sonner";

export function Providers({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const checkAuth = useAuthStore((state: AuthState) => state.checkAuth);
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { staleTime: 60 * 1000 },
          mutations: { retry: false },
        },
      }),
  );

  useEffect(() => {
    if (pathname !== "/login" && isPathRequiringAuth(pathname)) {
      checkAuth();
    }
  }, [pathname, checkAuth]);

  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider basePath="/api/auth">
        {children}
        <Toaster
          position="bottom-right"
          closeButton
          toastOptions={{
            style: { background: "white", boxShadow: "none" },
          }}
        />
      </SessionProvider>
    </QueryClientProvider>
  );
}